import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { FormValidationService } from '../../../../shared/services/form-validation.service';

@Component({
  selector: 'app-reference-area-import',
  template: require('./reference-area-import.component.html'),
  styles: [require('./reference-area-import.component.sass')]
})
export class ReferenceAreaImportComponent implements OnInit {

  @ViewChild('referenceAreaImportModal') referenceAreaImportModal: ElementRef;

  @Output() importReferenceAreas = new EventEmitter<FormData>();

  projectId: number;
  referenceAreaImportForm: FormGroup;
  referenceAreaImportModalReference: NgbModalRef;
  fileToUpload: File;
  displayHelp: boolean = false;
  fileName: string;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    public formValidation:FormValidationService
  ) {
    this.referenceAreaImportForm = this.fb.group({
      fileInput: ['', [Validators.required, validateFileFormat]]
    });
  }

  ngOnInit(): void {
    this.fileName = "";
    this.referenceAreaImportForm.valueChanges.subscribe(values => {
    })
  }

  async showModal(projectId: number) {
    this.fileName = '';
    this.referenceAreaImportForm.reset();
    this.projectId = projectId;

    this.referenceAreaImportModalReference = await this.modalService.open(this.referenceAreaImportModal, {
      size: 'xl'
    })
  }

  handleFileInput(event) {
    this.fileToUpload = event.target.files[0];
    if (this.fileToUpload) {
      this.fileName = this.fileToUpload.name;
    }
  }

  save = () => {
    if (this.referenceAreaImportForm.valid) {
      const formData = new FormData();
      formData.append('file', this.fileToUpload);
      this.importReferenceAreas.emit(formData);
      this.referenceAreaImportModalReference.close();
    } else {
      this.formValidation.validateAllFormFields(this.referenceAreaImportForm);
    }
  }
}

export function validateFileFormat(control: AbstractControl) {
  if (control.value && !control.value.endsWith('csv')) {
    return {wrongFileType: true};
  }
  return null;
}
